/**
 * @since 2026-04-18
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import React, { useState } from "react";
import { Box } from "@mui/material";
import EChart from "components/Shared/EChart";
import ChartCard from "components/Shared/ChartCard";
import { filterByPeriod } from "components/Shared/chartUtils";

const SourceDisagreementPanel = ({ detail }) => {
  const [period, setPeriod] = useState("all");
  if (!detail) return null;
  const { deviationSeries = {}, sources = [] } = detail;
  const seriesKeys = Object.keys(deviationSeries);
  if (sources.length === 0 && seriesKeys.length === 0) {
    return <Box sx={{ opacity: 0.7 }}>No per-source data available.</Box>;
  }
  if (sources.length <= 1 || seriesKeys.length <= 1) {
    const only = sources[0] || seriesKeys[0];
    return <Box sx={{ opacity: 0.7 }}>Only one source{only ? ` (${only})` : ""} — nothing to compare.</Box>;
  }

  const series = Object.entries(deviationSeries).map(([source, data]) => ({
    name: source,
    type: "line",
    showSymbol: false,
    data: filterByPeriod(data, period),
    lineStyle: { width: 1.5 },
  }));

  const option = {
    animation: false,
    legend: { data: Object.keys(deviationSeries), bottom: 0 },
    tooltip: { trigger: "axis" },
    grid: { left: 60, right: 30, top: 20, bottom: 60 },
    xAxis: { type: "time" },
    yAxis: { type: "value", scale: true, name: "Deviation", axisLabel: { formatter: (v) => `${(v * 100).toFixed(1)}%` } },
    series,
  };

  return (
    <ChartCard period={period} onPeriodChange={setPeriod}>
      <EChart option={option} height={400} />
    </ChartCard>
  );
};

export default SourceDisagreementPanel;
